import { ClaimApi } from './claimApi';

const claimApi = new ClaimApi();

export { claimApi };
